import { memo } from 'react';
import HeaderImportantInfo from './HeaderImportantInfo/HeaderImportantInfo';
import UnassignedCameraIcon from 'assets/icons/CameraStream/UnassignedCameraIcon';
import PropTypes from 'prop-types';

const CameraUnassignedInfo = ({ isUnassigned }) => {
    if (!isUnassigned) return null;

    return <HeaderImportantInfo icon={<UnassignedCameraIcon />} text="Unassigned" tooltipText="No one is available. Please assign manually" />;
};

CameraUnassignedInfo.propTypes = {
    isUnassigned: PropTypes.bool.isRequired,
};

export default memo(CameraUnassignedInfo);
